export default "__VITE_ASSET__ba64dc21__"